import React, {
    AnchorHTMLAttributes,
    ReactElement,
    ReactNode,
} from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { SizeTypes, VariantTypes } from "./Button";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    size?: SizeTypes;
    variant?: VariantTypes;
    prefixIcon?: ReactNode,
    postfixIcon?: ReactNode,
    isActive?: boolean,
    isClose?: boolean
    metricPath?: string[];
}

const Link = React.forwardRef((
    args: LinkProps,
    ref: React.ForwardedRef<HTMLAnchorElement>,
): ReactElement => {
    const {
        size, variant, prefixIcon, postfixIcon, isActive, isClose, onClick, metricPath, ...rest
    } = args;

    let icon = prefixIcon;

    if (!icon && isClose) {
        icon = <CloseIcon className="btn-icon-close" />;
    }
    const isOnlyIcon = !args.children && !postfixIcon;

    const clickHandler = metricPath ? LoggingHandler.instance.wrapMetricWithSnapshot(metricPath, onClick) : onClick;

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <a
            type="button"
            {...rest}
            ref={ref}
            onClick={clickHandler}
            className={
                `btn ${variant ? `btn-${variant}` : ""} ${size ? `btn-${size}` : ""} ${args.className}`
                + ` ${isOnlyIcon ? "btn-icon-only" : ""} ${isActive ? "active" : ""}`
            }
        >
            {icon && (
                <span className={`btn-icon ${isOnlyIcon ? "" : "btn-prefix-icon"}`}>
                    {icon}
                </span>
            )}

            {args.children}

            {postfixIcon && (
                <span className="btn-icon btn-postfix-icon">
                    {postfixIcon}
                </span>
            )}

        </a>
    );
});

Link.defaultProps = {
    variant: "outline-gray",
    className: "",
    prefixIcon: undefined,
    size: "medium",
    metricPath: undefined,
};

export default Link;
